import React from 'react';
import PropTypes from 'prop-types';

import {ProjectWrapper, ProjectIcon} from './Project.styles';

const Project = React.memo(({data, active, setActiveProject, icon}) => {
  const {id, position} = data;

  function getRelativePosition() {
    const mapWidth = 1080;
    const mapHeight = 1540;
    const relativePositionX = (position.x / mapWidth) * 100;
    const relativePositionY = (position.y / mapHeight) * 100;
    return {
      x: relativePositionX,
      y: relativePositionY,
    };
  }

  const relativePosition = getRelativePosition();
  function onClick() {
    setActiveProject(id, position);
  }

  const projectState = active
    ? active === id
      ? 'active'
      : 'inactive'
    : 'idle';

  return (
    <ProjectWrapper
      active={active === id}
      position={relativePosition}
      state={projectState}
    >
      <ProjectIcon
        onClick={onClick}
        className={`icon icon--waste ${projectState}`}
        active={active === id}
      >
        {icon()}
      </ProjectIcon>
    </ProjectWrapper>
  );
});

Project.propTypes = {
  data: PropTypes.object,
  active: PropTypes.string,
  setActiveProject: PropTypes.func,
  icon: PropTypes.func,
};

export default Project;
